import { useLang } from "../LanguageContext";
import { translations } from "../data/translations";
import { motion } from "framer-motion";
import { MapPin, Award, Truck } from "lucide-react";

export default function AboutSection() {
  const { lang } = useLang();
  const t = translations[lang];

  const highlights = [
    { icon: Award, title: "Chenbro", desc: "Offizieller Distributor" },
    { icon: Award, title: "AcBel", desc: "Industrial PSU Partner" },
    { icon: MapPin, title: "Hamburg", desc: "Deutschland HQ" },
    { icon: Truck, title: "EU-weit", desc: "Lieferung" }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-4">{t.about?.title || "Über FUM DA"}</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">{t.about?.subtitle || "Ihr Partner für Serverinfrastruktur"}</p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {highlights.map((item, idx) => (
            <motion.div key={idx} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: idx * 0.1 }} className="text-center p-6 bg-gray-50 rounded-xl">
              <item.icon className="w-10 h-10 text-brand-blue mx-auto mb-3" />
              <h3 className="font-bold text-gray-900">{item.title}</h3>
              <p className="text-sm text-gray-500">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
